import React, { useState, useEffect } from 'react';
import Map from "/components/services/map/Map";
import './Services.css';

function Services() {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);



  return (<>
   {isLoading && (
        <div className="loading-overlay">
          <div className="loading">Map loading...</div>
        </div>
      )}
      <Map />
  </>
  );
}

export default Services;